// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageSubCategoryItem-manageSubCategoryCardTopWrapper-Ypjls {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
}

.ManageSubCategoryItem-manageSubCategoryCardImgContainer-zWVpz {
    position: relative;
    width: 54px;
    height: 54px;
    border-radius: 6px 0 6px 0;
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ManageSubCategoryItem-manageSubCategoryCardImg-u0YQw {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: inherit;
}

.ManageSubCategoryItem-manageSubCategoryCardInfoContainer-jk9bg {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
}

.ManageSubCategoryItem-manageSubCategoryCardInfoName-irb6H,
.ManageSubCategoryItem-manageSubCategoryCardInfoQuantityCountText-v8skB {
    font-size: 14px;
    line-height: 24px;
}

.ManageSubCategoryItem-manageSubCategoryCardInfoName-irb6H {
    font-weight: 700;
    margin-bottom: 3px;
    color: var(--primary-foreground);
}

.ManageSubCategoryItem-manageSubCategoryCardInfoQuantityCountText-v8skB {
    font-weight: 400;
    color: var(--secondary-foreground);
}

.ManageSubCategoryItem-manageSubCategoryCardInfoQuantityCountText-v8skB span {
    display: inline-block;
}

.ManageSubCategoryItem-manageSubCategoryCardBottomWrapper-C3Pbb {
    border-top: 1px solid var(--primary-border);
    margin-top: 12px;
    padding-top: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
}

.ManageSubCategoryItem-manageSubCategoryCardInfoWrapper-U9DrO {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

.ManageSubCategoryItem-manageSubCategoryCardSwitchWrapper-YjTnv {
    -ms-flex-negative: 0;
        flex-shrink: 0;
}

.ManageSubCategoryItem-manageSubCategoryCardBottomText-C3nKb,
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw {
    font-size: 14px;
    line-height: 24px;
}

.ManageSubCategoryItem-manageSubCategoryCardBottomText-C3nKb {
    font-weight: 500;
    color: var(--primary-bg);
}

.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw {
    font-weight: 400;
}

.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw,
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw:hover,
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw:focus,
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw:not([href]):not([tabindex]),
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw:not([href]):not([tabindex]):hover,
.ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw:not([href]):not([tabindex]):focus {
    color: var(--primary-link-foreground);
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 6px;
    grid-gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/ManageSubCategory/ManageSubCategoryItem/ManageSubCategoryItem.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,oBAAc;QAAd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;AACb;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI,oBAAc;QAAd,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;;;IAMI,qCAAqC;IACrC,eAAe;IACf,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,QAAQ;IACR,aAAa;AACjB","sourcesContent":[".manageSubCategoryCardTopWrapper {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.manageSubCategoryCardImgContainer {\n    position: relative;\n    width: 54px;\n    height: 54px;\n    border-radius: 6px 0 6px 0;\n    flex-shrink: 0;\n}\n\n.manageSubCategoryCardImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n}\n\n.manageSubCategoryCardInfoContainer {\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.manageSubCategoryCardInfoName,\n.manageSubCategoryCardInfoQuantityCountText {\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.manageSubCategoryCardInfoName {\n    font-weight: 700;\n    margin-bottom: 3px;\n    color: var(--primary-foreground);\n}\n\n.manageSubCategoryCardInfoQuantityCountText {\n    font-weight: 400;\n    color: var(--secondary-foreground);\n}\n\n.manageSubCategoryCardInfoQuantityCountText span {\n    display: inline-block;\n}\n\n.manageSubCategoryCardBottomWrapper {\n    border-top: 1px solid var(--primary-border);\n    margin-top: 12px;\n    padding-top: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.manageSubCategoryCardInfoWrapper {\n    flex-grow: 1;\n}\n\n.manageSubCategoryCardSwitchWrapper {\n    flex-shrink: 0;\n}\n\n.manageSubCategoryCardBottomText,\n.manageSubCategoryCardBottomLink {\n    font-size: 14px;\n    line-height: 24px;\n}\n\n.manageSubCategoryCardBottomText {\n    font-weight: 500;\n    color: var(--primary-bg);\n}\n\n.manageSubCategoryCardBottomLink {\n    font-weight: 400;\n}\n\n.manageSubCategoryCardBottomLink,\n.manageSubCategoryCardBottomLink:hover,\n.manageSubCategoryCardBottomLink:focus,\n.manageSubCategoryCardBottomLink:not([href]):not([tabindex]),\n.manageSubCategoryCardBottomLink:not([href]):not([tabindex]):hover,\n.manageSubCategoryCardBottomLink:not([href]):not([tabindex]):focus {\n    color: var(--primary-link-foreground);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    grid-gap: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageSubCategoryCardTopWrapper": `ManageSubCategoryItem-manageSubCategoryCardTopWrapper-Ypjls`,
	"manageSubCategoryCardImgContainer": `ManageSubCategoryItem-manageSubCategoryCardImgContainer-zWVpz`,
	"manageSubCategoryCardImg": `ManageSubCategoryItem-manageSubCategoryCardImg-u0YQw`,
	"manageSubCategoryCardInfoContainer": `ManageSubCategoryItem-manageSubCategoryCardInfoContainer-jk9bg`,
	"manageSubCategoryCardInfoName": `ManageSubCategoryItem-manageSubCategoryCardInfoName-irb6H`,
	"manageSubCategoryCardInfoQuantityCountText": `ManageSubCategoryItem-manageSubCategoryCardInfoQuantityCountText-v8skB`,
	"manageSubCategoryCardBottomWrapper": `ManageSubCategoryItem-manageSubCategoryCardBottomWrapper-C3Pbb`,
	"manageSubCategoryCardInfoWrapper": `ManageSubCategoryItem-manageSubCategoryCardInfoWrapper-U9DrO`,
	"manageSubCategoryCardSwitchWrapper": `ManageSubCategoryItem-manageSubCategoryCardSwitchWrapper-YjTnv`,
	"manageSubCategoryCardBottomText": `ManageSubCategoryItem-manageSubCategoryCardBottomText-C3nKb`,
	"manageSubCategoryCardBottomLink": `ManageSubCategoryItem-manageSubCategoryCardBottomLink-mfAiw`
};
module.exports = ___CSS_LOADER_EXPORT___;
